/* tslint:disable */

declare var Object: any;
export interface TalentPoolWorkersInterface {
  "Name"?: string;
  "sfdcId"?: string;
  "Global_Talent_Pool__c"?: string;
  "Worker__c"?: string;
  "Worker_Account__c"?: string;
  "Worker_Account_Name__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class TalentPoolWorkers implements TalentPoolWorkersInterface {
  "Name": string;
  "sfdcId": string;
  "Global_Talent_Pool__c": string;
  "Worker__c": string;
  "Worker_Account__c": string;
  "Worker_Account_Name__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: TalentPoolWorkersInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TalentPoolWorkers`.
   */
  public static getModelName() {
    return "TalentPoolWorkers";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TalentPoolWorkers for dynamic purposes.
  **/
  public static factory(data: TalentPoolWorkersInterface): TalentPoolWorkers{
    return new TalentPoolWorkers(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TalentPoolWorkers',
      plural: 'TalentPoolWorkers',
      path: 'TalentPoolWorkers',
      idName: 'id',
      properties: {
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Global_Talent_Pool__c": {
          name: 'Global_Talent_Pool__c',
          type: 'string'
        },
        "Worker__c": {
          name: 'Worker__c',
          type: 'string'
        },
        "Worker_Account__c": {
          name: 'Worker_Account__c',
          type: 'string'
        },
        "Worker_Account_Name__c": {
          name: 'Worker_Account_Name__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
